import {HeaderItemWrapper, HeaderWrapper} from '@app/layout/MainHeader.styles';
import Text from '@atoms/Text';
import {Logout, UserFilled} from '@carbon/icons-react';
import {theme} from '@styles/theme';
import {useLocation, useNavigate} from 'react-router';
import {ERoutes} from '@constants/routes';
import {useDispatch, useSelector} from 'react-redux';
import {logout} from '@store/slices/users';
import {AppDispatch, RootState} from '@store';
import {useEffect} from 'react';
import {fetchProfile} from '@store/slices/profile';

export const MainHeader = () => {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const username = useSelector((state: RootState) => state.profile.profile?.username);

  useEffect(() => {
    dispatch(fetchProfile());
  }, []);
  const UserLogout = () => {
    dispatch(logout());
    navigate(ERoutes.AUTHORIZATION, {state: {from: location.pathname + location.search}});
  };

  return (
    <HeaderWrapper>
      <HeaderItemWrapper
        onClick={() => navigate(ERoutes.PROFILE)}
        currentPage={pathname == ERoutes.PROFILE}>
        <UserFilled size={16} fill={theme.colors.basic03} />
        <Text text={username ? username : '—'} type="bodyM" />
      </HeaderItemWrapper>
      <HeaderItemWrapper onClick={UserLogout}>
        <Text text="Выйти" type="bodyM" />
        <Logout size={16} fill={theme.colors.basic03} />
      </HeaderItemWrapper>
    </HeaderWrapper>
  );
};
